<template>
  <button
    v-if="!isUser"
    :class="btnClass"
    @click.prevent="blockUnblock"
  >
    {{ blocking ? 'Unblock' : 'Block' }}
  </button>
</template>

<script>
export default {
  name: 'BlockUnblock',
  props: {
    otherUser: { type: Object, required: true },
    btnClass: { type: String, required: false, default: 'btn btn-light btn-sm' },
  },
  computed: {
    isUser() {
      return this.userData.id === Number(this.otherUser.id);
    },
    currentUser() {
      if (this.isUser) {
        return this.userData;
      }
      return this.otherUser;
    },
    blocking() {
      return (
        !this.isUser && this.userData.blocking
        && this.userData.blocking.find(f => f.id === this.currentUser.id) !== undefined
      );
    },
  },
  methods: {
    async blockUnblock() {
      const responseData = await this.api({
        url: `users/${this.currentUser.id}/${this.blocking ? 'unblock' : 'block'}/`,
        method: this.blocking ? 'DELETE' : 'POST',
      });

      if (responseData.status === 200) {
        if (!this.userData.blocking) {
          this.userData.blocking = [];
        }
        if (!this.blocking) {
          this.userData.blocking.push({
            id: this.currentUser.id,
            first_name: this.currentUser.first_name,
            last_name: this.currentUser.last_name,
            avatar_url: this.currentUser.avatar_url,
          });
        } else {
          this.userData.blocking = this.userData.blocking.filter(
            f => f.id !== this.currentUser.id,
          );
        }
        this.$store.commit('userData', this.userData);
      } else {
        alert(
          'Unable to communicate with the server. Please check your '
          + 'connection and try again.',
        );
      }
    },
  },
};
</script>
